import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AccordionContainerModule } from '@dynamic-components/accordion-container';
import { BodyTextContainerComponent } from '@dynamic-components/body-text-container';
import { BodyTextImageContainerModule } from '@dynamic-components/body-text-image-container';
import { SectionRelatedContentBlockContainerModule } from '@dynamic-components/section-related-content-block-container';
import { RendererTemplateComponent } from '@dynamic-templates/renderer-template/renderer-template.component';
import { DOTDebugContentModule } from '@shared/debug-content/debug-content.module';
import { MobileAppStoreComponent } from '@shared/mobile-app-store/mobile-app-store.component';
import { StringToIdPipe } from '@shared/ui/pipes/string-to-id/string-to-id.pipe';

import { UIModule } from '../../shared/ui';
import { ContactUsModule } from '../contact-us/contact-us.module';
import { ContactUsReceiptModule } from '../contact-us-receipt/contact-us-receipt.module';
import { ContextualHelpContainerModule } from '../contextual-help-container/contextual-help-container.module';
import { ImageContainerModule } from '../image-container/image-container.module';
import { ListContainerModule } from '../list-container/list-container.module';
import { LogoIconArrayContainerModule } from '../logo-icon-array-container/logo-icon-array-container.module';
import { TableContainerModule } from '../table-container/table-container.module';
import { VideoContainerModule } from '../video-container/video-container.module';
import { JBSectionContainerComponent } from './section-container.component';

const MODULES = [
  CommonModule,
  DOTDebugContentModule,
  UIModule,
  BodyTextContainerComponent,
  BodyTextImageContainerModule,
  LogoIconArrayContainerModule,
  ContextualHelpContainerModule,
  AccordionContainerModule,
  ImageContainerModule,
  VideoContainerModule,
  ListContainerModule,
  TableContainerModule,
  SectionRelatedContentBlockContainerModule,
  ContactUsReceiptModule,
  ContactUsModule,
  RendererTemplateComponent,
];

const DECLARATIONS = [JBSectionContainerComponent];

const PROVIDERS = [StringToIdPipe];

@NgModule({
  imports: [...MODULES, MobileAppStoreComponent],
  declarations: [...DECLARATIONS],
  exports: [...MODULES, ...DECLARATIONS],
  providers: [...PROVIDERS],
})
export class JBSectionContainerModule {
  static entry = JBSectionContainerComponent;
}
